export const ADS_SIMULATOR_PAGE = [
  '113333408388614', //TEST LAZ 2
  '188869521221562' //Lazada
]



// WEBPACK FOOTER //
// ./src/constants/adsSimulator.js